export enum CategoryOperation {
    Plan = 1,
    Report,
}